import { HStack, Box, Image } from "@chakra-ui/react";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { useIntl } from "react-intl";

/**
 * @typedef {object} Props
 * @property {number} rate
 */

/**
 * @param {Props} props
 */
export default function RatingStars({ rate }) {
  const intl = useIntl();
  const fullStars = Math.floor(rate >= 5 ? 5 : rate);

  const hasHalfStar = rate - fullStars > 0 && rate - fullStars < 1;

  /**
   *
   * @param {"full" | "half"} type
   * @param {number} index
   * @returns
   */
  const renderStar = (type, index) => {
    let filePath = "icon/star.svg";
    if (type === "half") {
      filePath = "icon/star-half.svg";
    }

    return (
      <Box key={index}>
        <Image
          src={generateFrontPath({
            id: "@front.internal-assets",
            parameters: { filePath },
            includeBasePath: true,
          })}
          alt={`${type} star`}
          maxW="24px"
          maxH="24px"
        />
      </Box>
    );
  };

  return (
    <HStack
      spacing={1}
      title={intl.formatMessage(
        { defaultMessage: "Note: {rate}/5" },
        { rate },
      )}>
      {[...Array(fullStars)].map((_, i) => renderStar("full", i))}

      {hasHalfStar && renderStar("half", fullStars)}
    </HStack>
  );
}
